/** Public shared startup profile (/p/:token) copy. Part of `UI_STRINGS` - see ui-strings.ts. */
export const UI_SHARED_PROFILE_STRINGS = {
  SHARED_PROFILE: {
    EXPIRED_HEADING: 'This Link Is No Longer Active',
    EXPIRED_BODY:
      'The startup profile link you followed has either expired or been revoked by the sender. Please reach out to the person who shared this link to request a new one.',
    EXPIRED_CTA: 'Go to My NEXT Raise',
    EXPIRED_FOOTNOTE: 'If you believe this is an error, contact the person who shared this link with you.',
    SECURE_ACCESS_BADGE: 'SECURE ACCESS',
    SHARED_WITH_YOU: 'has shared their Startup Profile with you',
    VERIFY_HEADING: 'Verify Your Email to Continue',
    VERIFY_SUBTITLE:
      "We'll send a one-time code to confirm your identity before granting access to this startup profile.",
    EMAIL_LOCKED_HINT: 'This is the email address this profile was shared with.',
    SEND_CODE: 'Send Verification Code',
    SENDING_CODE: 'Sending…',
    TERMS_AGREEMENT_PREFIX: 'By verifying your email you agree to view this profile in accordance with ',
    TERMS_AGREEMENT_LINK: "My NEXT Raise's Terms & Conditions",
    TERMS_AGREEMENT_SUFFIX: '.',
    OTP_HEADING: 'Enter Your Verification Code',
    OTP_SUBTITLE_PREFIX: 'We sent a 6-digit code to ',
    OTP_SUBTITLE_SUFFIX: '. Enter it below to access the startup profile.',
    VERIFY_CODE: 'Verify Code',
    VERIFYING_CODE: 'Verifying…',
    NO_CODE: "Didn't receive it?",
    RESEND: 'Resend',
    RESEND_IN_PREFIX: 'Resend in ',
    RESENDING: 'Sending…',
    RESENT: 'A new code is on its way if the address is registered.',
    ERROR_INVALID: 'That code is incorrect. Please try again.',
    ERROR_EXPIRED: 'That code has expired. Request a new one.',
    ERROR_LOCKED: 'Too many attempts. Request a new code.',
    ERROR: 'That code is invalid or expired. Please try again.',
    SEND_CODE_ERROR: 'We could not send your code. Please try again.',
    BROWSE_POPUP_HEADING: 'Leaving the Startup Profile View',
    BROWSE_POPUP_BODY:
      'If you navigate to the public pages, you will leave this startup profile view. To return and view the startup profile again, you will need to use the original link shared with you and verify your email again.',
    BROWSE_POPUP_CONFIRM: 'Are you sure you want to continue?',
    BROWSE_POPUP_CONTINUE: 'Yes, Go to My NEXT Raise',
    BROWSE_POPUP_STAY: 'Stay on Profile',
    BROWSE_POPUP_FOOTNOTE: 'Your secure access to this profile is tied to the original link. Bookmark it before leaving.',
    BROWSE_PUBLIC_PAGES: 'Go to My NEXT Raise',
    READ_ONLY_BADGE: 'Read Only',
    SHARED_SECURELY: 'Shared securely via My NEXT Raise',
    NOT_VERIFIED_ERROR: 'Please verify your email to continue.',
  },
} as const;
